import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IDesenDetaySatinAlma_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IDesenDetaySatinAlma_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  GoBack: any;
  GoBack_dummy: any;
  GetInvoicePurchaseCollectionCharSelectDesign: any[];
  GetInvoicePurchaseCollectionCharSelectDesign_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  SetValueOf: any;
  SetValueOf_dummy: any;
  ExportExcel: any;
  ExportExcel_dummy: any;
  Notify: boolean;
  Notify_dummy: boolean;
  isComp295122Visible: "visible" | "hidden";
  isComp428423Visible: "visible" | "hidden";
}

export class DesenDetaySatinAlma_ScreenBase extends React.PureComponent<
  IDesenDetaySatinAlma_ScreenProps,
  any
> {
  desendetaysatinalma_487654_value_kuikaSelectBoxRef: React.RefObject<any>;
  desendetaysatinalma_666246_value_kuikaSelectBoxRef: React.RefObject<any>;
  desendetaysatinalma_536224_value_kuikaDateRef: React.RefObject<any>;
  desendetaysatinalma_27617_value_kuikaDateRef: React.RefObject<any>;
  desendetaysatinalma_265841_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "7c73d7e5-3e39-4165-ae6e-89678c5fbd5d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 431057, PropertyName: "value", Value: "Desen Seç" },
        { Id: 701175, PropertyName: "value", Value: "Tedarikçi Adı" },
        { Id: 717934, PropertyName: "value", Value: "21.02.2025" },
        { Id: 177915, PropertyName: "value", Value: "-" },
        { Id: 716883, PropertyName: "value", Value: "21.02.2025" },
        { Id: 24250, PropertyName: "value", Value: "Koleksiyon Adı" },
        { Id: 298341, PropertyName: "value", Value: "Toplam Adet" },
        { Id: 350131, PropertyName: "value", Value: "Toplam Metrekare" },
        { Id: 640527, PropertyName: "value", Value: "Toplam Fiyat" },
        { Id: 408159, PropertyName: "placeholder", Value: "Desen Adı..." },
        {
          Id: 487654,
          PropertyName: "placeholder",
          Value: "miktar/metrekare/tutar",
        },
        { Id: 666246, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 160836, PropertyName: "value", Value: "Başlangıç Tarihi" },
        {
          Id: 536224,
          PropertyName: "placeholder",
          Value: "Başlangıç Tarihi Seçiniz...",
        },
        { Id: 373147, PropertyName: "value", Value: "Bitiş Tarihi" },
        {
          Id: 27617,
          PropertyName: "placeholder",
          Value: "Bitiş Tarihi Seçiniz...",
        },
        { Id: 652832, PropertyName: "label", Value: "Filtreyi Uygula" },
        { Id: 381199, PropertyName: "label", Value: "Ara" },
        { Id: 682170, PropertyName: "label", Value: "Temizle" },
        { Id: 30916, PropertyName: "value", Value: "Export Excel" },
        {
          Id: 265841,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 707378, PropertyName: "title", Value: "Title" },
        {
          Id: 565975,
          PropertyName: "value",
          Value: "[datafield:productatt05desc]",
        },
        { Id: 492478, PropertyName: "value", Value: "Miktar" },
        { Id: 576788, PropertyName: "value", Value: "[datafield:miktar]" },
        { Id: 955658, PropertyName: "value", Value: "Metrekare" },
        { Id: 370054, PropertyName: "value", Value: "[datafield:metrekare]" },
        { Id: 76680, PropertyName: "value", Value: "Tutar TL" },
        { Id: 254454, PropertyName: "value", Value: "[datafield:tutar]" },
        { Id: 299578, PropertyName: "value", Value: "Tutar Dolar" },
        { Id: 875406, PropertyName: "value", Value: "[datafield:tutaru]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.desendetaysatinalma_408159_value_kuikaTextInputRef = React.createRef();
    this.desendetaysatinalma_487654_value_kuikaSelectBoxRef = React.createRef();
    this.desendetaysatinalma_666246_value_kuikaSelectBoxRef = React.createRef();
    this.desendetaysatinalma_536224_value_kuikaDateRef = React.createRef();
    this.desendetaysatinalma_27617_value_kuikaDateRef = React.createRef();
    this.desendetaysatinalma_265841_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      GoBack: "",
      GetInvoicePurchaseCollectionCharSelectDesign: [],
      ChangeVisibilityOf: "",
      SetValueOf: "",
      ExportExcel: "",
      Notify: false,
      dataSource_487654: [
        { key: "0", text: "Miktar Bazında" },
        { key: "1", text: "Metrekare Bazında" },
        { key: "2", text: "Tutar Bazında" },
      ],
      dataSource_666246: [
        { key: "10", text: "İki Tarih Arasını Filtrele" },
        { key: "8", text: "Ay Başından Bu Yana" },
        { key: "9", text: "Geçen Ay" },
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son 6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      isComp295122Visible: "hidden",
      isComp428423Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("desendetaysatinalma", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.DesenDetaySatinAlmaPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("desendetaysatinalma", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("desendetaysatinalma", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.DesenDetaySatinAlmaPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  DesenDetaySatinAlmaPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      ),
      DesignName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "DesenDetaySatinAlma/DesenDetaySatinAlmaPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseCollectionCharSelectDesign =
      result?.data.getInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.DesenDetaySatinAlmaPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseCollectionCharSelectDesign ??
      this.state.GetInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_195637_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "DesenDetaySatinAlma",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "700727",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_491995_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_487654_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      ),
      DesignName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_408159_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_487654_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_536224_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_27617_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "DesenDetaySatinAlma/DesenDetaySatinAlmaComponent_487654_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseCollectionCharSelectDesign =
      result?.data.getInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.DesenDetaySatinAlmaComponent_487654_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_487654_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseCollectionCharSelectDesign ??
      this.state.GetInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_666246_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      ),
      DesignName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_408159_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_487654_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_536224_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_27617_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        ReactSystemFunctions.convertToTypeByName("10", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "DesenDetaySatinAlma/DesenDetaySatinAlmaComponent_666246_onChange",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.GetInvoicePurchaseCollectionCharSelectDesign =
        result?.data.getInvoicePurchaseCollectionCharSelectDesign;

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange1_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_666246_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp295122Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("visible", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange2_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_666246_onChange2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.ChangeVisibilityOf =
        await ReactSystemFunctions.changeVisibilityOf(
          this,
          ReactSystemFunctions.convertToTypeByName(
            "isComp295122Visible",
            "string"
          ),
          ReactSystemFunctions.convertToTypeByName("hidden", "string")
        );

      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange3_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_666246_onChange3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange4_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_666246_onChange4_();
          resolve();
        });
      });
    }

    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_666246_onChange4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "10"
      )
    ) {
      stateVars.dataSource_265841 =
        stateVars.GetInvoicePurchaseCollectionCharSelectDesign ??
        this.state.GetInvoicePurchaseCollectionCharSelectDesign;

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_652832_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      ),
      DesignName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_408159_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_487654_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_536224_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_27617_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "DesenDetaySatinAlma/DesenDetaySatinAlmaComponent_652832_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseCollectionCharSelectDesign =
      result?.data.getInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.DesenDetaySatinAlmaComponent_652832_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_652832_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseCollectionCharSelectDesign ??
      this.state.GetInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_381199_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      ),
      DesignName_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_408159_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_666246_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      filter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_487654_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      StartDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_536224_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      EndDate_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "desendetaysatinalma_27617_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "DesenDetaySatinAlma/DesenDetaySatinAlmaComponent_381199_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseCollectionCharSelectDesign =
      result?.data.getInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.DesenDetaySatinAlmaComponent_381199_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_381199_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseCollectionCharSelectDesign ??
      this.state.GetInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_682170_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      ),
      ProductAtt03Desc_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      ),
      DesignName_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      filter_0: ReactSystemFunctions.convertToTypeByName(0, "number"),
      StartDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
      EndDate_0: ReactSystemFunctions.convertToTypeByName("", "string"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "DesenDetaySatinAlma/DesenDetaySatinAlmaComponent_682170_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseCollectionCharSelectDesign =
      result?.data.getInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.DesenDetaySatinAlmaComponent_682170_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_682170_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "desendetaysatinalma_408159_value",
        "string"
      ),
      "",
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "desendetaysatinalma_487654_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("0", "string"),
      null,
      "Key"
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "desendetaysatinalma_666246_value",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("3", "string"),
      null,
      "Key"
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp295122Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("hidden", "string")
      );

    stateVars.dataSource_265841 =
      stateVars.GetInvoicePurchaseCollectionCharSelectDesign ??
      this.state.GetInvoicePurchaseCollectionCharSelectDesign;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_982624_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      value_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          this.state.GetInvoicePurchaseCollectionCharSelectDesign
        ),
        "any"
      ),
      header_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      footer_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
      columns_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("", "string"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "9e0c0f32_0a51_0616_f771_ae782989a4da_confirmation",
        this.defaultML,
        "Desen bazında satın alım raporu almak istiyor musunuz?"
      ),
      "poppins",
      "Confirmation",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "DesenDetaySatinAlma/DesenDetaySatinAlmaComponent_982624_onClick",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.ExportExcel = result?.data.exportExcel;
      ReactSystemFunctions.downloadFile(result?.data?.exportExcel);
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.DesenDetaySatinAlmaComponent_982624_onClick1_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  DesenDetaySatinAlmaComponent_982624_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "8bdd8814_97b0_d484_5c02_e4649451c3a4_notify",
        this.defaultML,
        "Rapor oluşturuldu"
      ),
      ReactSystemFunctions.convertToTypeByName("success", "string"),
      ReactSystemFunctions.convertToTypeByName("top", "string"),
      2,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  DesenDetaySatinAlmaComponent_839481_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "CustomerName",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerName ??
          this.props.screenInputs.customername,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "CollectionName",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CollectionName ??
          this.props.screenInputs.collectionname,
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "DesignName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "desendetaysatinalma_265841_value",
          "productAtt05Desc"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "TotalQty1",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "desendetaysatinalma_265841_value",
          "miktar"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "TotalQty2",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "desendetaysatinalma_265841_value",
          "metreKare"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "TotalAmount",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          "desendetaysatinalma_265841_value",
          "tutar"
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "EbatDetaySatinAlma",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.CustomerCode ??
          this.props.screenInputs.customercode,
        "string"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "DesenDetaySatinAlma",
      "EbatDetaySatinAlma",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [700727] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.DesenDetaySatinAlmaPageInit();
    }
  }
}
